import React from 'react';
import Pill from '../../Pill/Pill';
import * as S from './CellFormatter.styles';

export const NumberFormatter = ({ cell, formatExtraData }) =>
  cell ? (
    <S.Cell align={formatExtraData.align}>
      <Pill variant='info'>{cell.text}</Pill>
    </S.Cell>
  ) : null;
